import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ContractualTermsDataGrid } from "src/components/views/erp/sales/masterData/contractualTerms/ContractualTermsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/contractualTerms")({
	staticData: { title: i18n.t("contractual_terms"), legacyViewKey: "contractualTermsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ContractualTermsDataGrid />;
}
